import { render, staticRenderFns } from "./ScaleWorkspaceBanner.vue?vue&type=template&id=14087b9a&scoped=true"
import script from "./ScaleWorkspaceBanner.vue?vue&type=script&lang=js"
export * from "./ScaleWorkspaceBanner.vue?vue&type=script&lang=js"
import style0 from "./ScaleWorkspaceBanner.vue?vue&type=style&index=0&id=14087b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14087b9a",
  null
  
)

export default component.exports